import React from 'react';

function Test() {

    // fetch('https://api.nvdxavier.com/api/curriculum/5')
    //     .then(response => response.json())
    //     .then(data => console.log(data))
    //     .catch(error => console.error('Erreur:', error));
    return (<React.Fragment>
        hello
        </React.Fragment>
    )
}

export default Test;